import React from 'react';
import Footer from '../../components/footer';
import { Link } from '@reach/router';
import EditCollection from './EditCollection'


const Gallery = ({ walletAddress }) => {

  return (
    <div>

      <EditCollection />
      <Footer />
    </div>);
}
export default Gallery;